// @flow
import React from 'react';
import { withTheme } from '@material-ui/core/styles';

type Props = {
  cursor: Array<string>,
  highlighted: boolean,
  participants: Array<Object>,
  scribe: boolean,
  scribeSelectTranscriptWord: Function,
  theme: Object,
  transcriptId: number,
  unlocked: boolean,
  allowEdit: boolean,
  word: string,
  wordIndex: number,
};

const parseWord = (word, classes = '', cursor, participants) => {
  let participant = {};
  (participants || []).forEach(p => {
    if ((cursor || []).includes(p.hash)) {
      participant = p;
    }
  });

  if (word[0] === '`' && word[word.length - 1] === '`') {
    return parseWord(word.slice(1, word.length - 1), `${classes} tr-edited`);
  }
  if (word[0] === '~' && word[word.length - 1] === '~') {
    return parseWord(word.slice(1, word.length - 1), `${classes} tr-disabled`);
  }
  const shownWord = cursor && !word ? ' ' : word;
  return (
    <>
      {participant.avaId && (
        <span
          style={{
            position: 'absolute',
            fontSize: 12,
            marginTop: -14,
            borderLeft: 'solid',
            borderWidth: 2,
            borderColor: cursor ? 'darkred' : undefined,
            paddingLeft: 3,
            backgroundColor: 'rgba(10,10,10,0.5)',
            pointerEvents: 'none',
          }}
        >
          {participant.userName}
        </span>
      )}
      <span
        className={classes}
        id={participant.userName}
        style={{
          backgroundColor: cursor ? 'darkred' : undefined,
          color: participant.avaId ? 'white' : undefined,
        }}
      >
        {shownWord}
      </span>
    </>
  );
};

const ScribeWord = ({
  allowEdit,
  cursor,
  highlighted,
  participants,
  scribe,
  scribeSelectTranscriptWord,
  theme,
  transcriptId,
  unlocked,
  word,
  wordIndex,
}: Props) => (
  <span>
    {/* eslint-disable-next-line */}
    <span
      style={{
        whiteSpace: 'pre-wrap',
        backgroundColor: scribe && unlocked ? 'rgba(100, 100, 100, 0.2)' : undefined,
        fontWeight: theme.palette.bold === 'true' || highlighted ? 'bold' : undefined,
      }}
      onClick={() =>
        allowEdit
          ? scribeSelectTranscriptWord({
              index: wordIndex,
              indexTranscript: transcriptId,
              skipCommit: true,
              skipJumpNextBloc: true,
            })
          : null
      }
      role="button"
    >
      {parseWord(word, '', allowEdit ? cursor : undefined, participants)}
    </span>{' '}
  </span>
);
export default withTheme(ScribeWord);
